import { colors } from "@crehana/ui";
const { purple: purple, baseMain: baseMain, white: white } = colors;
const COMMON_THEME_VALUES = {
    nav: {
        height: {
            xs: 56,
            sm: 72,
            md: 72,
            lg: 72
        },
        sidebarHeightClassName: 'h-48',
        dashboardPaddingClassNames: 'pt-24 pb-24 sm:pt-40 sm:pb-32',
        zIndex: 999
    },
    submenu: {
        drawerWidth: {
            xs: '100%',
            sm: '375px',
            md: '375px',
            lg: '375px'
        },
        userMenuPopperWidth: 375,
        middlePopperWidth: 1152
    },
    searchInput: {
        width: 300,
        smallWidth: 254
    }
};
const DEFAULT_MAIN_MENU_NAV_THEMES = {
    light: {
        ...COMMON_THEME_VALUES.nav,
        backgroundColorClassName: 'bg-white',
        textColorClassName: 'text-base-main',
        iconColorClassName: 'text-base-main',
        iconWithHoverColorClassName: 'text-base-main hover:text-primary-light',
        dividerColorClassName: 'border-gray-main',
        logo: {
            color: purple,
            secondaryColor: baseMain
        }
    },
    dark: {
        ...COMMON_THEME_VALUES.nav,
        backgroundColorClassName: 'bg-base-dark',
        textColorClassName: 'text-white',
        iconColorClassName: 'text-white',
        iconWithHoverColorClassName: 'text-white hover:text-secondary-light',
        dividerColorClassName: 'border-base-lighter',
        logo: {
            color: white,
            secondaryColor: white
        }
    }
};
const DEFAULT_MAIN_MENU_SUBMENU_THEMES = {
    light: {
        ...COMMON_THEME_VALUES.submenu,
        backgroundColorClassName: 'bg-white',
        textColorClassName: 'text-base-main',
        secondaryTextColorClassName: 'text-base-lighter',
        popperIndicatorColorClassName: 'text-white',
        linkHoverClassName: 'hover:bg-gray-lighter hover:text-primary-light',
        textLinkHoverClassName: 'hover:text-primary-light',
        accentIconColorClassName: 'text-primary-main',
        logoutColorClassName: 'text-base-lighter',
        dividerColorClassName: 'border-gray-light',
        backdropColorClassName: 'bg-base-lighter-56',
        logoColorClassName: 'text-purple-main'
    },
    dark: {
        ...COMMON_THEME_VALUES.submenu,
        backgroundColorClassName: 'bg-base-lighter-dark-mode',
        textColorClassName: 'text-white',
        secondaryTextColorClassName: 'text-secondary-lighter',
        popperIndicatorColorClassName: 'text-base-lighter-dark-mode',
        dividerColorClassName: 'border-gray-main-dark-mode',
        linkHoverClassName: 'hover:bg-gray-main-dark-mode hover:text-secondary-light',
        textLinkHoverClassName: 'hover:text-secondary-light',
        accentIconColorClassName: 'text-secondary-light',
        logoutColorClassName: 'text-base-lighter',
        backdropColorClassName: 'bg-base-main-80',
        logoColorClassName: 'text-white'
    }
};
const DEFAULT_MAIN_MENU_SEARCH_INPUT_THEMES = {
    light: {
        ...COMMON_THEME_VALUES.searchInput,
        accentBackgroundColorClassName: 'bg-primary-lighter border-primary-lighter',
        accentIconColorClassName: 'text-white'
    },
    dark: {
        ...COMMON_THEME_VALUES.searchInput,
        accentBackgroundColorClassName: 'bg-primary-lighter border-primary-lighter',
        accentIconColorClassName: 'text-white'
    }
};
const DEFAULT_MAIN_MENU_SEARCH_DIALOG_THEMES = {
    light: {
        searchInput: {
            adornmentColorClassName: 'text-base-lighter',
            accentAdornmentColorClassName: 'text-primary-main'
        }
    },
    dark: {
        searchInput: {
            adornmentColorClassName: 'text-white',
            accentAdornmentColorClassName: 'text-secondary-main'
        }
    }
};
export { COMMON_THEME_VALUES, DEFAULT_MAIN_MENU_NAV_THEMES, DEFAULT_MAIN_MENU_SEARCH_DIALOG_THEMES, DEFAULT_MAIN_MENU_SEARCH_INPUT_THEMES, DEFAULT_MAIN_MENU_SUBMENU_THEMES };
